import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, tap } from 'rxjs';
import { ApiService } from '@app/core/services/api/api.service';
import { QueryParameters } from '@app/core/entities/query-parameters.class';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { DeliverCursorPagination } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.model';
import { DeletedOrdersActions } from '../store/actions';
import { TABLES } from '@utils/table.utils';

@Injectable()
export class DeletedOrdersCursorPaginationService extends DeliverCursorPaginationService<Record<string, never>> {
  private apiService = inject(ApiService);
  private store = inject(Store);

  table = TABLES.DELETED;

  protected fetchOrdersFromApi(
    params: DeliverCursorPagination.OrdersRequest,
  ): Observable<DeliverCursorPagination.OrdersResponse> {
    return this.apiService.post('order/v2/orders', params).pipe(
      tap((response) => {
        this.store.dispatch(
          DeletedOrdersActions.loadDeletedOrdersSuccess({
            orders: response.orders,
            count: response.orders.length,
          }),
        );
      }),
    );
  }

  protected fetchCountFromApi(query: QueryParameters): Observable<DeliverCursorPagination.CappedCount> {
    return this.apiService.post('order/v2/count', query);
  }

  protected fetchTabCountersFromApi(): Observable<Record<string, never>> {
    return EMPTY;
  }
}
